module.exports = __webpack_public_path__ + "assets/pass-angle@2x-[fullhash:8].png";